import { StyleDictionary } from 'pdfmake/interfaces';

export const sharedStyles: StyleDictionary = {
  h1: {
    fontSize: 18,
    bold: true,
    alignment: "center",
    color: '#058ff4',
    margin: [0, 0, 0, 10],
  },
  h2: {
    fontSize: 14,
    bold: true,
    alignment: 'center',
    color: '#058ff4',
    margin: [0, 0, 0, 10],
  },
  subheader: {
    fontSize: 14,
    bold: true,
    alignment: 'center',
    margin: [0, 0, 0, 10],
  },
  p: {
    fontSize: 10,
    alignment: 'justify',
    lineHeight: 1.2,
    margin: [20, 0, 0, 10],
    preserveLeadingSpaces: true
  },
  input: {
    margin: [0, 20, 0, 5],
  },
  label: {
    fontSize: 10,
    bold: true,
  },
  ul: {
    fontSize: 11
  },
  tableHeader: {
    bold: true,
    fontSize: 10,
    margin: [0, 4, 0, 4]
  },
  tableCell: {
    fontSize: 10,
    margin: [0, 4, 0, 4]
  },
  footer: {
    margin: [0, 0, 0, 20],
  },
};
